import * as React from 'react';
import styled from '../../utils/styled';
import MenuItem from './MenuItem';
import {MenuProps} from './types';

const Root = styled('div')<{fullWidth: boolean}>(
  ({theme}) => ({
    fontFamily: theme.fontFamily.base,
    fontSize: 14,
    fontWeight: 200,
    textAlign: 'left',
    background: '#1B202A',
    overflowY: 'scroll'
  }),
  ({fullWidth}) => {
    if (fullWidth) {
      return {
        width: '100%'
      };
    }
    return {
      maxWidth: 200
    };
  }
);

export default class Menu extends React.Component<MenuProps, {}> {
  public render() {
    const {
      items: _items,
      renderItem,
      children,
      fullWidth,
      ...restProps
    } = this.props;

    const items =
      _items && _items.length > 0
        ? _items.map((itemProps, index) => (
            <MenuItem render={renderItem} {...itemProps} key={index} />
          ))
        : children;

    return (
      <Root fullWidth={Boolean(fullWidth)} {...restProps}>
        {items}
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.tsx